import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';

import { CustomerLocation, Customer } from 'types';
import { ContainerState } from './types';

// The initial state of the CustomerControls container
export const initialState: ContainerState = {
  customers: [],
  customersLoading: false,
  selectedCustomer: '',
  locations: null,
  locationsLoading: false,
  locationError: '',
  selectedLocation: null,
  hasCustomerSelector: true,
  hasLocationSelector: true,
  path: '/c/:customerId/dashboard/:locationId',
};

const customerControlsSlice = createSlice({
  name: 'customerControls',
  initialState,
  reducers: {
    getCustomers(state: ContainerState, action: PayloadAction): ContainerState {
      return { ...state, customersLoading: true };
    },
    getCustomersSuccess(state, action: PayloadAction<Customer[]>) {
      return {
        ...state,
        customersLoading: initialState.customersLoading,
        customers: action.payload,
      };
    },
    getCustomersFailure(state, action: PayloadAction<string>) {
      return {
        ...state,
        customersLoading: initialState.customersLoading,
        customers: initialState.customers,
        customersError: action.payload,
      };
    },
    setSelectedCustomer(state, action: PayloadAction<string>) {
      return {
        ...state,
        selectedCustomer: action.payload,
        locations: [],
        locationsLoading: true,
      };
    },
    changeSelectedCustomer(state, action: PayloadAction<string>) {
      return {
        ...state,
        selectedCustomer: action.payload,
        locations: [],
        locationsLoading: true,
      };
    },

    getCustomerLocations(state, action: PayloadAction<string>) {
      return { ...state, locations: [], locationsLoading: true };
    },
    getCustomerLocationsSuccess(
      state,
      action: PayloadAction<CustomerLocation[]>,
    ) {
      return {
        ...state,
        locationsLoading: initialState.locationsLoading,
        locations: action.payload,
      };
    },
    getCustomerLocationsFailure(state, action: PayloadAction<string>) {
      return {
        ...state,
        locationsLoading: initialState.locationsLoading,
        locations: initialState.locations,
        locationError: action.payload,
      };
    },
    setSelectedLocation(state, action: PayloadAction<string>) {
      return {
        ...state,
        selectedLocation: action.payload,
      };
    },
    changeSelectedLocation(state, action: PayloadAction<string>) {
      return {
        ...state,
        selectedLocation: action.payload,
      };
    },
    setHasCustomerSelector(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        hasCustomerSelector: action.payload,
      };
    },
    setHasLocationSelector(state, action: PayloadAction<boolean>) {
      return {
        ...state,
        hasLocationSelector: action.payload,
      };
    },
    setPath(state, action: PayloadAction<string>) {
      return {
        ...state,
        path: action.payload,
      };
    },
    updateCustomersList(state, action: PayloadAction<Customer>) {
      return {
        ...state,
        customers: state.customers.map(customer =>
          customer.id === action.payload.id ? action.payload : customer,
        ),
      };
    },
  },
});

export const { actions, reducer, name: sliceKey } = customerControlsSlice;
